import React, { useState, useEffect } from "react";
import useErrorHandler from "@beeldit/core/errors/useErrorHandler";
import index from "@beeldit/core/services";
import { Pet } from "../models/Pet";

interface Option {
  label: string;
  value: number | string;
  fee: string;
}

function MultiSelector(props: any) {
  const { id, value, required, disabled, readonly, onChange, formContext } =
    props;
  const [selectedOptions, setSelectedOptions] = useState<(number | string)[]>(
    []
  );
  const [options, setOptions] = useState<Option[]>([]);
  const [elementsData, setElementsData] = useState({ elements: [] });

  const errorHandler = useErrorHandler();
  const { element } = formContext;

  useEffect(() => {    
    if (!element.customer_id) {
      setElementsData({ elements: [] });
    }
    index("pets", "relations=fee&customer_id=" + element.customer_id)
      .then((response: any) => {        
        setElementsData(response.data);
      })
      .catch((error: any) => {
        errorHandler(error, null);
      });
  }, [element.customer_id]);

  useEffect(() => {
    const newOptions = elementsData.elements.map((pet: Pet) => {
      return { label: pet.name, value: pet.id, fee: pet.fee.name, breed: pet.breed }; // Incluye la tarifa (fee)
    });
    setOptions(newOptions);

    const currentSelectedOptions = value && Array.isArray(value) ? value : [];
    setSelectedOptions(currentSelectedOptions);
  }, [elementsData, value]);

  const handleCheckboxChange = (optionValue: number | string) => {
    const updatedSelectedOptions = selectedOptions.includes(optionValue)
      ? selectedOptions.filter((v) => v !== optionValue)
      : [...selectedOptions, optionValue];

    setSelectedOptions(updatedSelectedOptions);
    onChange(updatedSelectedOptions);
  };

  return (
    <div id={id}>
      {/* Renderizar tabla */}
      <table className="table">
        <thead>
          <tr>
            <th>Nombre</th>
            <th>Rafa</th>
            <th>Tarifa</th>
            <th className="text-center">Seleccionar</th>
          </tr>
        </thead>
        <tbody>
          {options.length > 0 && options.map((option: any, index) => (
            <tr key={index}>
              <td>{option.label}</td>
              <td>{option.breed}</td>
              <td>{option.fee}</td>
              <td className="text-center">
                <input
                  className="form-check-input"
                  type="checkbox"
                  id={`${id}-${index}`}
                  name={id}
                  value={option.value}
                  checked={selectedOptions.includes(option.value)}
                  disabled={disabled || readonly}
                  onChange={() => handleCheckboxChange(option.value)}
                />
              </td>
            </tr>
          ))}
          {
            (options.length == 0) && (
              <tr>
                <td colSpan={3} className="text-center">No hay mascotas disponibles</td>
              </tr>
            )
          }
        </tbody>
      </table>
    </div>
  );
}

function PetCheckboxesSelector(props: any) {
  const { id, value, required, disabled, readonly, onChange, formContext } =
    props;
  return (
    <>
      <MultiSelector
        id={id}
        value={value}
        required={required}
        disabled={disabled}
        readonly={readonly}
        onChange={onChange}
        formContext={formContext}
      />
    </>
  );
}

export default PetCheckboxesSelector;
